<template>
  <div class="detail-search-item-container row" >
    <span>&nbsp;&nbsp;</span>
    <div ref="text">{{text}}</div>
  </div>
</template>
    
<script>
import Mark from 'mark.js';

export default {
  name: 'DetailSearchItem',
  props: {
    keyWords: {
      required: false,
      type: Array
    },
    text: {
      required: true,
      type: String
    },
    page: {
      required: true,
      type: Number
    }
  },
  methods: {
    highlight() {
      const textInstance = new Mark(this.$refs.text);
      textInstance.mark(this.keyWords || [], {
        element: 'span',
        className: 'highlight'
      });
    }
  },
  mounted() {
    this.highlight();
  }
};
</script>
    
<style lang="scss" scoped>
.detail-search-item-container {
  color: #747990;
  cursor: pointer;
}
</style>
